import React from "react";

import moment from "moment";

import { formatDate, getFarmIdFromLocalStorage, goTo, useNavigate, useTranslation, useUserContext } from "utils";

import { Card, Icon, NotificationPreviewCard, Skeleton, Svg, Typography } from "components";

export const NotificationCard = ({ notification, handleNotificationClickCallback }) => {
  const { t } = useTranslation("notifications");
  const navigate = useNavigate();
  const { switchFarm } = useUserContext();

  const getIcon = () => {
    if (notification.type === "tasks" && notification.route.includes("task")) {
      return (
        <div className="icon red white-text">
          <Icon iconName="klim/farm" size="m" />
        </div>
      );
    }
    if ((notification.type === "tasks" && notification.route.includes("rewards")) || notification.type === "funding") {
      return (
        <div className="icon green white-text">
          <Icon iconName="klim/money-plant" size="m" />
        </div>
      );
    }
    if (notification.type === "tasks") {
      return (
        <div className="icon rapeseed-yellow ">
          <Icon iconName="klim/plus" size="m" />
        </div>
      );
    }
    if (notification.type === "wallet") {
      return (
        <div className="icon green white-text">
          <Icon iconName="tabler/wallet" size="m" />
        </div>
      );
    }
    if (notification.type === "article") {
      return (
        <div className="icon green white-text">
          <Icon iconName="tabler/book" size="m" />
        </div>
      );
    }
    if (notification.type === "news" || notification.type === "feature") {
      return (
        <div className="icon logo">
          <Svg svgName="logos/klim_logo_brandmark" size="1.75rem" />
        </div>
      );
    }
    return (
      <div className="icon logo">
        <Svg svgName="logos/klim_logo_brandmark" size="1.75rem" />
      </div>
    );
  };

  const getDate = () => {
    const hours = Math.floor(Math.abs(moment.duration(moment(notification.date, "DD-MM-YYYY HH:MM").diff(moment())).asHours()));
    const days = Math.floor(Math.abs(moment.duration(moment(notification.date, "DD-MM-YYYY HH:MM").diff(moment())).asDays()));

    if (hours < 1) {
      return t("times.now");
    }
    if (hours < 24) {
      return t("times.hour", { hours: hours, count: hours });
    }
    if (hours < 48) {
      return t("times.yesterday");
    }
    if (days < 6) {
      return t("times.day", { days: days, count: days });
    }
    return formatDate(notification.date, "DD.MM.YYYY", "DD-MM-YYYY HH:MM");
  };

  const getTitle = () => {
    let title = notification.description;

    if (notification.type === "article") {
      title = t("titles.article");
    }
    if (notification.type === "news") {
      title = t("titles.news");
    }
    if (notification.type === "feature") {
      title = t("titles.feature");
    }
    if (notification.type === "funding") {
      title = notification.headline.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "");
    }
    return (
      <Typography variant="paragraph-s" bold>
        {title}
      </Typography>
    );
  };

  const clickNotification = (e) => {
    const location = notification.route;

    // Because the use can receive notifications for different farms,
    // if notification belongs to specific farm we want to set it in the local storage
    // before navigating
    if (notification.farm) {
      const localFarmId = getFarmIdFromLocalStorage();

      if (localFarmId !== notification.farm.id) {
        switchFarm(notification.farm.id);
      }
    }

    if (location) {
      goTo(e, navigate, `/${location.replace("progress/wallet", "wallet")}`);
    }
    handleNotificationClickCallback();
  };

  return (
    <>
      {notification ? (
        <Card
          className={`notification-card ${notification.route ? "clicky" : ""} ${!notification.read ? "unread" : ""}`}
          onClick={(e) => clickNotification(e)}
          mixpanelText={`notification-card ${notification.headline}`}
        >
          <div className="content">
            {getIcon()}
            <div className="details">
              <div>
                <Typography variant="paragraph-s" className="margin-0">
                  {getTitle()}
                </Typography>
              </div>
              <Typography variant="paragraph-s" color="grey-600" className="margin-0">
                {getDate()}
              </Typography>
            </div>
            {!notification.read ? <span className="dot" /> : <span className="no-dot" />}
          </div>
          <NotificationPreviewCard notification={notification} />
        </Card>
      ) : (
        <Card className="notification-card">
          <div className="content">
            <Skeleton type="title" />
            <Skeleton type="paragraph" rows={1} />
          </div>
        </Card>
      )}
    </>
  );
};

export default NotificationCard;
